// extracted by mini-css-extract-plugin
module.exports = {"link":"AuthNav_link__32esy","active":"AuthNav_active__3YlZb AuthNav_link__32esy"};